import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BrowserAPIService} from "@bloomscorp/ngbase";
import {Image} from "../../../interface/image";
import {isEmptyString} from "bmx-pastebox";
import {ImageGallerySeo} from "../../interface/image-gallery-seo";

@Component({
	selector: 'fb-thumbnails',
	templateUrl: './thumbnails.component.html',
	styleUrls: ['./thumbnails.component.scss']
})
export class ThumbnailsComponent implements OnInit {

	constructor(
		private _browser: BrowserAPIService,
	) {
	}

	@Input() thumbnails: ImageGallerySeo[] = [];
	@Input() videoThumbnail: Image = {} as Image;
	@Input() addOnImagePassOn: string = '';

	@Output() thumIndex: EventEmitter<number> = new EventEmitter<number>();

	public ngOnInit(): void {
		if (!isEmptyString(this.videoThumbnail.url)) {
			this.thumbnails.splice(1, 0, { image: this.videoThumbnail.url, altText: this.videoThumbnail.altText , deleted: false });
			this.thumbnails = [...new Set(this.thumbnails)];
		}
	}

	public click_thumb(i: number): void {

		let section: HTMLElement | null = document.getElementById('img_' + i);

		if (section !== null) {
			section.scrollIntoView({
				behavior: 'smooth'
			});
		}

		this.thumIndex.emit(i);
	}

	public clickThumbAddOnImage(): void {
		this.click_thumb(-1);
		if (this._browser.isBrowser())
			window.scrollTo(0, 0);
	}
}
